import { render, staticRenderFns } from "./wyShenheModal.vue?vue&type=template&id=f7f45bb8&scoped=true"
import script from "./wyShenheModal.vue?vue&type=script&lang=js"
export * from "./wyShenheModal.vue?vue&type=script&lang=js"
import style0 from "./wyShenheModal.vue?vue&type=style&index=0&id=f7f45bb8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7f45bb8",
  null
  
)

export default component.exports